import { render, staticRenderFns } from "./ItemGroup.vue?vue&type=template&id=c1d63810&scoped=true"
import script from "./ItemGroup.vue?vue&type=script&lang=ts"
export * from "./ItemGroup.vue?vue&type=script&lang=ts"
import style0 from "./ItemGroup.vue?vue&type=style&index=0&id=c1d63810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d63810",
  null
  
)

export default component.exports